import * as React from "react";
var ServerContext = /*#__PURE__*/ React.createContext(undefined);
export default ServerContext;
